module.exports = __webpack_public_path__ + "img/logo2.eb0d1aff.png";